import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";

export interface DropdownOption {
    label: string;
    value: string | number;
}

const ChevronDown = FiChevronDown as any;

interface SelectDropdownProps {
    label?: string;
    name: string;
    value: string | number;
    onChange: (value: string | number) => void;
    options: DropdownOption[];
    error?: string;
    icon?: string;
    isSearchable?: boolean;
    borderBotttom?: boolean;
    overlay?: boolean;
    custome?: boolean;
}

const CustomDropdown: React.FC<SelectDropdownProps> = ({
    label,
    name,
    value,
    onChange,
    options,
    error,
    icon,
    isSearchable = true,
    borderBotttom,
    overlay,
    custome
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const dropdownRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const filteredOptions = options.filter(o =>
        o.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Close dropdown when clicking outside
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    // Auto focus input
    useEffect(() => {
        if (isOpen && isSearchable && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isOpen, isSearchable]);

    const selectedLabel =
        options.find(o => o.value === value)?.label || "Select";

    return (
        <div className="w-full" ref={dropdownRef}>

            {/* {label && <label className="custom_label">{label}</label>} */}

            <div className="relative">
                <div
                    className={`
                    h-[48px] border-x-[1px] border-[#F5F6F7] ps-3 flex items-center cursor-pointer 
                    focus:outline-none focus:ring-0
                    ${borderBotttom ? "border-y-2" : "border-t-2"}
                `}
                    onClick={() => setIsOpen(!isOpen)}
                    tabIndex={0} // Needed for keyboard but we remove outline
                    style={{ outline: "none" }}
                >
                    {/* Left Icon */}
                    {icon && (
                        <img
                            src={icon}
                            alt="icon"
                            className={` ${overlay ? "absolute left-4 w-[20px] h-[20px] opacity-45" : "absolute left-3 w-[25px] h-[25px] pointer-events-none"}`}
                        />
                    )}
                    {/* Input / Selected */}
                    {isOpen && isSearchable ? (
                        <input
                            ref={inputRef}
                            className={`w-full bg-transparent outline-none border-none text-[13px] 2xl:text-[16px] text-[#747474] 
                            ${icon ? "ps-10" : "ps-2"} !py-0`}
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                border: 'none',
                                background: 'transparent',
                                outline: 'none',
                                boxShadow: 'none',
                                color: '#747474',
                            }}
                        />
                    ) : (
                        <span
                            className={`text-[13px] 2xl:text-[16px] text-[#747474] ${icon ? "ps-10" : ""}`}
                        >
                            {selectedLabel}
                        </span>
                    )}

                    {/* Right Icon */}
                    <ChevronDown
                        className={`absolute right-3 transition-transform duration-200 pointer-events-none 
                        ${isOpen ? "rotate-180" : ""}`}
                        size={18}
                        color="#777"
                    />
                </div>

                {/* Dropdown menu */}
                {isOpen && (
                    <ul className="absolute
      left-1/2
      -translate-x-1/2
      w-[90%]
      mt-1
      bg-white
      border border-gray-300
      rounded-lg
      shadow-lg
      max-h-44
      no-scrollbar
      overflow-y-auto
      p-0 z-20">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((opt) => (
                                <li
                                    key={opt.value}
                                    onClick={() => {
                                        onChange(opt.value);
                                        setIsOpen(false);
                                    }}
                                    className={`px-3 py-2 hover:bg-gray-100 cursor-pointer 
                                    ${custome ? "text-[#676767] text-[11px] xl:text-[13px]" : "text-[#333]"}`}
                                >
                                    {opt.label}
                                </li>
                            ))
                        ) : (
                            <li className="px-3 py-2 text-gray-500">No options</li>
                        )}
                    </ul>
                )}
            </div>

            {error && <p className="text-red-500 text-sm ps-10">{error}</p>}
        </div>
    );
};

export default CustomDropdown;
